import React, { PropsWithChildren } from 'react';
import Modal from '@ux/modal';
import { useIntl } from 'react-intl';
import { IntlKeysType } from '../../constants/IntlKeys';

type Props = {
  titleKey?: IntlKeysType;
  onClose?: () => void;
};

export const Popup = ({ children, titleKey, onClose }: PropsWithChildren<Props>) => {
  const intl = useIntl();

  const childrenArray = React.Children.toArray(children);

  const actionsContent = childrenArray.find(
    child => React.isValidElement(child) && child.type === Popup.Actions
  );
  const content = childrenArray.filter(
    child => React.isValidElement(child) && child.type !== Popup.Actions
  );

  return (
    <Modal
      title={titleKey && intl.formatMessage({ id: titleKey })}
      onClose={onClose}
      actions={<>{actionsContent}</>}
    >
      <p>{content}</p>
    </Modal>
  );
};
Popup.Actions = (props: PropsWithChildren<unknown>) => <>{props.children}</>;
